export default () => {
    if (typeof epi !== 'undefined' &&
        typeof epi.EPiServer !== 'undefined' &&
        typeof epi.EPiServer.Forms !== "undefined") {
        // extend the EpiForm JavaScript API in ViewMode
        $$epiforms(".EPiServerForms").on("formsStepValidating",
            function (event, param1, param2) {
                var firstFailedElement = jQuery(".Form__Element.ValidationFail")[0];
                if (!firstFailedElement) {
                    return;
                }
                var position = jQuery(firstFailedElement).offset().top - 130;
                jQuery("body, html").animate({
                    scrollTop: position
                },
                    200);
                jQuery("[data-f-datainput]", firstFailedElement).focus();
            });
        jQuery.extend(true,
            epi.EPiServer.Forms,
            {
                // extend the Validator to validate Visitor's value in Clientside.        
                Validators: {
                    "Transportforetagen.Web.ElementBlocks.GdprElementBlock.GdprValidator": function (fieldName,
                        fieldValue,
                        validatorMetaData) {
                        // this function is used to validate visitor's data value in ViewMode
                        let condition = fieldValue.length > 0;
                        if (!condition) {
                            return { isValid: false, message: validatorMetaData.model.message };
                        }
                        return { isValid: true };
                    }
                }
            });
    }
}


